import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "profile",
  style: {"margin-top":"10px"}
}
const _hoisted_2 = { class: "card-grid" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "profile-box" }
const _hoisted_6 = {
  key: 0,
  class: "profile-box-content"
}
const _hoisted_7 = { style: {"width":"30%","overflow":"hidden"} }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { style: {"width":"60%","text-align":"center"} }
const _hoisted_10 = { style: {"color":"black","font-size":"40px"} }
const _hoisted_11 = { style: {"color":"black","font-size":"25px"} }
const _hoisted_12 = { style: {"color":"black","font-size":"25px"} }
const _hoisted_13 = { class: "card-image-wrapper" }
const _hoisted_14 = { class: "card-image" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = {
  class: "pagination",
  style: {"margin-top":"50px","color":"black"}
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = ["src"]

import { ref, computed, watch, onMounted } from 'vue'
import axios from '../../api/files'
import { useRoute, useRouter } from 'vue-router'
import axiospr from '../../api/profile'

const itemsPerPage = 15


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberGallery',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const crt = ref('')
const currentPage = ref(Number(route.query.page) || 1)

const isSmallScreen = ref(window.innerWidth <= 920);

onMounted(() => {
  isSmallScreen.value = window.innerWidth <= 920;
  window.addEventListener('resize', () => {
    isSmallScreen.value = window.innerWidth <= 920;
  });
});


watch(currentPage, (newPage) => {
  router.replace({ query: { ...route.query, page: newPage } })
})

watch(currentPage, () => {
  fetchMembers()
})

watch(crt, () => {
  currentPage.value = 1;
  fetchMembers();
});

async function fetchProfile() {
  try {
    const response = await axiospr.ListProfile()
    profile.value = response.data.list || []
  }
  catch (error) {
    console.error('멤버 목록을 불러오는 데 실패했습니다:', error)
  }
}

const showModal = ref(false)
const selectedImage = ref('')
const showProfile = ref(false)
const allImagesLoaded = ref(false)

// 페이징
const totalItems = ref(0)
const members = ref([]);

const profile = ref([]); // `profile`은 `fetchProfile`에서 채워짐
const selectedMemberNo = ref<any>(null);


const displayedMembers = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage
  const end = start + itemsPerPage
  return members.value.slice(start, end)
})


async function fetchMembers() {
  try {
    const response = await axios.fetchFiles({
      crt: crt.value,
      page: currentPage.value - 1,
      rows: itemsPerPage,
    })
    console.log(response.data)
    members.value = response.data.list || []
    totalItems.value = response.data.total || 0
    allImagesLoaded.value = true


  } catch (error) {
    console.error('멤버 목록을 불러오는 데 실패했습니다:', error)
  }
}

function changePage(direction: 'next' | 'prev') {
  if (direction === 'next' && currentPage.value < totalPages.value) {
    currentPage.value++
  } else if (direction === 'prev' && currentPage.value > 1) {
    currentPage.value--
  }
}

const totalPages = computed(() => {
  return totalItems.value === 0
    ? 1
    : Math.ceil(totalItems.value / itemsPerPage);
});


function openModal(imageUrl: string) {
  selectedImage.value = imageUrl
  showModal.value = true
}

function closeModal() {
  showModal.value = false
}

function showProfileBox(member: any) {
  if (isSmallScreen.value) {
    return;
  }
  selectedMemberNo.value = member
  crt.value = member.no
  fetchMembers()
  console.log(crt.value)
  showProfile.value = true
}

// 프로필 박스 닫기
function closeProfileBox() {
  showProfile.value = false
}

function handleAfterLeave() {
  selectedMemberNo.value = null;
  crt.value = "";
  fetchMembers();
}


onMounted(async () => {
  await fetchMembers();
  await fetchProfile();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isSmallScreen.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[2] || (_cache[2] = _createElementVNode("h1", { style: {"margin-bottom":"10px"} }, "멤버 프로필", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profile.value, (member) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: member.no,
                  class: "member-card",
                  onClick: ($event: any) => (showProfileBox(member))
                }, [
                  _createElementVNode("img", {
                    src: member.path,
                    alt: member.title,
                    class: "member-img"
                  }, null, 8, _hoisted_4)
                ], 8, _hoisted_3))
              }), 128))
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "slide-down",
      onAfterLeave: handleAfterLeave
    }, {
      default: _withCtx(() => [
        (showProfile.value && !isSmallScreen.value)
          ? (_openBlock(), _createElementBlock("div", {
              class: "profile-filter-section",
              key: selectedMemberNo.value?.memberNo
            }, [
              _createElementVNode("div", _hoisted_5, [
                (selectedMemberNo.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("section", _hoisted_7, [
                        _createElementVNode("img", {
                          src: selectedMemberNo.value.path,
                          alt: selectedMemberNo.value.title,
                          class: "member-profile",
                          style: {"width":"259px","height":"323px","object-fit":"cover"}
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("section", _hoisted_9, [
                        _createElementVNode("h1", _hoisted_10, _toDisplayString(selectedMemberNo.value.title), 1),
                        _createElementVNode("h2", _hoisted_11, "\"" + _toDisplayString(selectedMemberNo.value.subContent) + "\"", 1),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(selectedMemberNo.value.content), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (showProfile.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "close-btn",
                    onClick: closeProfileBox
                  }, "닫기"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _cache[3] || (_cache[3] = _createElementVNode("h1", { style: {"margin-bottom":"10px"} }, "갤러리", -1)),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedMembers.value, (member) => {
          return (_openBlock(), _createElementBlock("div", {
            key: member.no,
            class: "member-card-image",
            onClick: ($event: any) => (openModal(member.path))
          }, [
            _createElementVNode("img", {
              src: member.path,
              alt: member.name,
              class: "member-img"
            }, null, 8, _hoisted_16)
          ], 8, _hoisted_15))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changePage('prev'))),
        disabled: currentPage.value === 1
      }, "Previous", 8, _hoisted_18),
      _createElementVNode("span", null, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPages.value), 1),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (changePage('next'))),
        disabled: currentPage.value === totalPages.value
      }, "Next", 8, _hoisted_19)
    ]),
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "modal-overlay",
          onClick: _withModifiers(closeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("img", {
              src: selectedImage.value,
              alt: "확대 이미지",
              class: "modal-img"
            }, null, 8, _hoisted_21),
            _createElementVNode("button", {
              class: "modal-close",
              onClick: closeModal
            }, "×")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})